var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"d-none",attrs:{"type":"file","id":"listupload","accept":".xlsx"},on:{"change":_vm.importFile}}),_c('g-button',{staticClass:"mr-2",attrs:{"icon":"cloud_upload","label":"Import List"},on:{"onclick":function($event){return _vm.openFileUpload()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }